import { ActionModalSize } from './action-modal.enum';

export interface ActionModal {
    iconPath?: string;
    title: string;
    description?: string;
    primaryButton?: ActionModalButton;
    secondaryButton?: ActionModalButton;
    secondaryNoButton?: ActionModalButton;
    size?: ActionModalSize;
    hideCloseButton?: boolean;
}

export interface ActionModalButton {
    label: string;
    action: () => void;
    disabled?: boolean;
}
